import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, plural, type ActionDeps } from "./types";

export function duplicateAction(ids: number[], deps: ActionDeps): QueuedAction {
	const n = ids.length;

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: "/records/duplicate",
				method: "POST",
				body: { ids },
			}),
		rollback: null,
		toast: {
			loading: `Duplicating ${n} ${plural(n)}…`,
			success: `Duplicated ${n} ${plural(n)}`,
			error: "Failed to duplicate entries",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
